import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import { Form, Input, Icon } from 'semantic-ui-react';
import CancelGoButtons from 'components/CancelGoButtons';
import API from 'utils/api';

class MenuProductCostDirectForm extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      valid: false,
      loading: true,
      error: null,
      product: null,
      productId: null,
      cost: ''
    };

    this.costInputRef = React.createRef();
  }

  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.loadProduct);
  }

  componentDidUpdate(prevProps, prevState) {
    // Focus the cost input when loading is done
    if (prevState.loading && !this.state.loading) {
      if (this.costInputRef.current) {
        this.costInputRef.current.focus();
      }
    }
  }
  
  loadProduct = () => {
    API.getProduct(this.state.productId)
      .then((response) => {
        this.setState({ 
          product: response.data,
          loading: false,
          // Initialize cost if it exists
          cost: response.data.cost ? response.data.cost.toString() : ''
        }, this.validate);
      })
      .catch((error) => {
        console.error(error);
        this.setState({ 
          error: 'Error al cargar el producto',
          loading: false
        });
      });
  }

  handleCost = (event) => {
    const cost = parseFloat(event.target.value);

    if (event.target.value === '') {
      this.setState({ cost: '' }, this.validate);
    }

    if (!isNaN(cost)) {
      this.setState({ cost: event.target.value }, this.validate);
    }
  }
  
  validate = () => {
    let valid = true;
    if (this.state.cost === '') { valid = false; }
    if (isNaN(parseFloat(this.state.cost))) { valid = false; }
    this.setState({ valid });
  }

  updateProductCost = () => {
    if (this.state.valid) {
      this.setState({ loading: true, error: null });
      
      const params = {
        cost: this.state.cost
      };

      API.updateProductCost(this.state.productId, params)
        .then((response) => {
          // Go back to the product page
          this.props.history.push(`/menu/products/${this.state.productId}`);
        })
        .catch((error) => {
          console.error(error);
          this.setState({ 
            error: 'Error al actualizar el costo del producto',
            loading: false
          });
        });
    }
  }

  render() {
    const formTitle = this.state.product ? `Costo directo: ${this.state.product.name}` : 'Agregar costo directo';
    
    if (this.state.loading) {
      return (
        <div>
          <Header text={formTitle} />
          <div style={{ textAlign: 'center', padding: '2em' }}>
            <Icon loading name='spinner' size='large' />
            <p style={{ marginTop: '1em', color: '#666' }}>Cargando producto...</p>
          </div>
        </div>
      );
    }
    
    if (!this.state.product) {
      return (
        <div>
          <Header text="Error" />
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            No se encontró el producto
          </div>
          <div style={{ marginTop: '2em' }}>
            <CancelGoButtons 
              cancelFn={() => this.props.history.push('/menu/products')}
              cancelText="regresar"
              hideGoButton={true}
              style={{
                button: {
                  height: '54px',
                  fontSize: '1.1em',
                  fontWeight: 'bold',
                  boxShadow: 'none',
                  borderRadius: '8px'
                }
              }}
            />
          </div>
        </div>
      );
    }
    
    return (
      <div>
        <Header text={formTitle} />
        
        <p style={{ 
          margin: '1em 0', 
          padding: '12px', 
          backgroundColor: '#f8f8f9', 
          borderRadius: '4px',
          fontSize: '1.1em',
          color: '#666'
        }}>
          Ingresa el costo directo para productos como bebidas, empaquetados, u otros artículos que no se preparan.
        </p>
        
        {this.state.error && (
          <div style={{ 
            color: '#db2828', 
            margin: '1.5em 0', 
            padding: '12px', 
            backgroundColor: '#fff6f6', 
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            {this.state.error}
          </div>
        )}
        
        <Form as="div" style={{ marginTop: '1.5em' }}>
          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              COSTO
            </label>
            <Input
              ref={this.costInputRef}
              type="number"
              step="0.10"
              icon="dollar sign"
              iconPosition="left"
              value={this.state.cost}
              onChange={this.handleCost}
              placeholder="0.00"
              style={{ fontSize: '1.2em', height: '54px' }}
            />
          </Form.Field>
          
          <CancelGoButtons
            cancelFn={() => this.props.history.push(`/menu/products/${this.state.productId}/cost`)}
            cancelText="regresar"
            goText="guardar"
            goFn={this.updateProductCost}
            goEnabled={this.state.valid && !this.state.loading}
            loading={this.state.loading}
            style={{
              button: {
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }
            }}
          />
        </Form>
      </div>
    );
  }
}

export default withRouter(MenuProductCostDirectForm); 